import { useSelector, useDispatch } from 'react-redux';
import { setRestaurantCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { selectCheckedEndorsements } from '../../../../selectors/application';
import EndorsementCard from '../../EndorsementCard';
import { config } from './RestaurantCoverage.config';

const { endorsementKey: ENDORSEMENT_KEY, label: LABEL, description: DESCRIPTION } = config;

const RestaurantCoverage = () => {
  const dispatch = useDispatch();
  const isSelected = useSelector(selectCheckedEndorsements).includes(ENDORSEMENT_KEY);

  const handleCheckboxChange = (checked: boolean) => {
    dispatch(setCheckedEndorsement(ENDORSEMENT_KEY, checked));
    dispatch(setRestaurantCoverage(checked ? true : null));
  };

  return (
    <EndorsementCard
      endorsementKey={ENDORSEMENT_KEY}
      label={LABEL}
      description={DESCRIPTION}
      isSelected={isSelected}
      onCheckboxChange={handleCheckboxChange}
    />
  );
};

export default RestaurantCoverage;
